import { Outlet } from 'react-router-dom';

/** 大屏列表与画布编辑子路由 */
export default function DisplaysLayout() {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <Outlet />
    </div>
  );
}
